export default "__VITE_ASSET__QA6kWwn0__"